import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { DefaultStyledProps } from '@savgroup-front-common/types';

interface LogoContainerProps extends DefaultStyledProps {
  componentThemeName?: string;
}

export const $LoginImageContainer = styled.div<LogoContainerProps>`
  max-width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: ${spacing('xxl')};
  position: relative;
  z-index: 2;
`;

export const $LoginImg = styled.img`
  width: auto;
  display: block;
  max-height: ${spacing(96)};
  max-width: 80%;
  transform: translateY(-${spacing(11)});
`;
